module.exports = __webpack_public_path__ + "img/9.e8f1b958.gif";